import React from 'react';

export interface PictureProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    webp: string;
    fallback: string;
}

export default function Picture({ webp, fallback, alt = '', className, ...imgProps }: PictureProps) {
    return (
        <picture>
            <source srcSet={webp} type="image/webp" />
            <img src={fallback} alt={alt} className={className} {...imgProps} />
        </picture>
    );
}
